/*
  BDEK product page (sections/bdek-main-product.liquid)
  - Option buttons: marks each value in stock / pre-order (dot) / sold out, given the other choices.
  - Picking a pre-order size shows "Selling fast / [size] sold out. Pre-order now. Ships in …",
    switches the button to "Pre-order · Ships in …" and adds the Pre-order line property.
  - Adds to cart with /cart/add.js, then fires Impulse's "ajaxProduct:added" so the cart drawer opens.
  - Size guide dialog, phone swipe counter, free-shipping bar, sticky add bar on phones.
*/
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Shopify can hand this over wrapped in quotes; the rest follows the store's currency format
    format = (format || '${{amount}}').replace(/["']/g, '');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  function init(root) {
    if (root.dataset.bdekProductReady) return;
    root.dataset.bdekProductReady = 'true';

    var dataEl = root.querySelector('[data-bdek-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var labels = data.labels;
    var variants = data.variants;

    var form = root.querySelector('[data-bdek-product-form]');
    var idInput = root.querySelector('[data-bdek-variant-input]');
    var preorderInput = root.querySelector('[data-bdek-preorder-input]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-bdek-option]'));
    var addBtn = root.querySelector('[data-bdek-add]');
    var addText = root.querySelector('[data-bdek-add-text]');
    var status = root.querySelector('[data-bdek-status]');
    var urgency = root.querySelector('[data-bdek-urgency]');
    var message = root.querySelector('[data-bdek-message]');
    var priceNow = root.querySelector('[data-bdek-price-current]');
    var priceWas = root.querySelector('[data-bdek-price-compare]');
    var dynamic = root.querySelector('[data-bdek-dynamic]');
    var gallery = root.querySelector('[data-bdek-gallery]');
    var sticky = root.querySelector('[data-bdek-sticky]');
    var stickyBtn = root.querySelector('[data-bdek-sticky-btn]');
    var stickyPrice = root.querySelector('[data-bdek-sticky-price]');
    var notify = root.querySelector('[data-bdek-notify]');
    var notifyVariant = null;

    // Back in stock: show the form only for a sold-out size
    function setNotify(variant) {
      if (!notify) return;
      var show = !!(variant && !variant.available);
      if (show && notifyVariant !== variant.id) {
        var st = notify.querySelector('[data-bdek-notify-status]');
        if (st) st.textContent = '';
        notify.querySelector('[data-bdek-notify-form]').hidden = false;
      }
      notifyVariant = show ? variant.id : null;
      notify.hidden = !show;
    }

    function selectedValues() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('[data-bdek-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      if (!fieldsets.length) return variants[0];
      if (values.indexOf(null) !== -1) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.every(function (o, idx) { return o === values[idx]; })) return v;
      }
      return null;
    }

    // Best state of a value, given the other options already chosen: 2 in stock, 1 pre-order, 0 sold out
    function valueState(optionIndex, value, values) {
      var best = 0;
      variants.forEach(function (v) {
        if (v.options[optionIndex] !== value) return;
        var matches = v.options.every(function (o, idx) {
          return idx === optionIndex || values[idx] === null || values[idx] === o;
        });
        if (!matches || !v.available) return;
        best = Math.max(best, v.preorder ? 1 : 2);
      });
      return best;
    }

    // The size (or other) name to use in messages
    function variantName(variant) {
      if (!fieldsets.length) return '';
      var sizeIdx = -1;
      fieldsets.forEach(function (fs, idx) {
        var legend = fs.querySelector('.bdek-option__legend');
        if (sizeIdx === -1 && legend && /size/i.test(legend.textContent)) sizeIdx = idx;
      });
      return sizeIdx > -1 ? variant.options[sizeIdx] : variant.options.join(' / ');
    }

    function setButton(text, disabled, preorder) {
      addText.textContent = text;
      addBtn.disabled = disabled;
      addBtn.classList.toggle('is-preorder', !!preorder);
      if (stickyBtn) {
        stickyBtn.textContent = text;
        stickyBtn.classList.toggle('is-preorder', !!preorder);
      }
    }

    function setMessage(showUrgency, text) {
      urgency.hidden = !showUrgency;
      message.textContent = text || '';
      status.classList.toggle('has-message', !!text);
    }

    function refresh(fromUser) {
      var values = selectedValues();

      fieldsets.forEach(function (fs, optionIndex) {
        var chosen = fs.querySelector('[data-bdek-option-input]:checked');
        var selectedLabel = fs.querySelector('[data-bdek-option-selected]');
        if (selectedLabel) selectedLabel.textContent = chosen ? chosen.value : labels.selectPrompt;

        fs.querySelectorAll('[data-bdek-value]').forEach(function (label) {
          var state = valueState(optionIndex, label.getAttribute('data-bdek-value'), values);
          label.classList.toggle('is-preorder', state === 1);
          label.classList.toggle('is-soldout', state === 0);
          var sr = label.querySelector('[data-bdek-value-state]');
          if (sr) sr.textContent = state === 1 ? ', ' + labels.preorderState : state === 0 ? ', ' + labels.soldOut : '';
        });
      });

      var variant = findVariant(values);

      if (!variant) {
        idInput.value = '';
        preorderInput.disabled = true;
        var anyMissing = values.indexOf(null) !== -1;
        setButton(anyMissing ? labels.choose : labels.unavailable, true, false);
        setMessage(false, anyMissing ? '' : labels.unavailable);
        if (dynamic) dynamic.hidden = true;
        setNotify(null);
        return;
      }
      setNotify(variant);

      idInput.value = variant.id;
      if (fromUser) document.dispatchEvent(new CustomEvent('bdek:variant-change', { detail: { variantId: variant.id } }));
      priceNow.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (priceWas) {
        priceWas.hidden = !variant.compare;
        var wasText = priceWas.lastChild;
        if (variant.compare && wasText) wasText.textContent = variant.compare;
      }

      var name = variantName(variant);
      if (!variant.available) {
        preorderInput.disabled = true;
        setButton(labels.soldOut, true, false);
        setMessage(false, name ? name + ' ' + labels.soldOutMessage : '');
        if (dynamic) dynamic.hidden = true;
      } else if (variant.preorder) {
        preorderInput.disabled = false;
        preorderInput.value = variant.shipping;
        setButton(labels.preorderButton + ' ' + variant.shipping, false, true);
        setMessage(true, (name ? name + ' ' : '') + labels.preorderMessage + ' ' + variant.shipping + '.');
        // Buy-now skips the cart, so the pre-order note wouldn't be seen; keep pre-orders to the cart
        if (dynamic) dynamic.hidden = true;
      } else {
        preorderInput.disabled = true;
        setButton(labels.add, false, false);
        setMessage(false, '');
        if (dynamic) dynamic.hidden = false;
      }

      if (fromUser) {
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
        if (variant.media && gallery) {
          var slide = gallery.querySelector('[data-media-id="' + variant.media + '"]');
          if (slide) {
            if (window.matchMedia('(max-width: 989px)').matches) {
              gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
            }
          }
        }
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-bdek-option-input]')) refresh(true);
    });

    // Back in stock signup → Klaviyo client API (public site ID only; no private key on the page)
    if (notify) {
      var notifyForm = notify.querySelector('[data-bdek-notify-form]');
      var notifyEmail = notify.querySelector('[data-bdek-notify-email]');
      var notifyStatus = notify.querySelector('[data-bdek-notify-status]');
      notifyForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = notifyEmail.value.trim();
        if (!email || !notifyEmail.checkValidity() || !notifyVariant) {
          notifyEmail.setAttribute('aria-invalid', 'true');
          notifyStatus.textContent = notifyStatus.getAttribute('data-invalid');
          notifyEmail.focus();
          return;
        }
        notifyEmail.removeAttribute('aria-invalid');
        var button = notifyForm.querySelector('[type="submit"]');
        button.disabled = true;
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(notify.getAttribute('data-company')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notifyVariant } }
              }
            }
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            notifyForm.hidden = true;
            notifyStatus.textContent = notifyStatus.getAttribute('data-success');
          })
          .catch(function () {
            notifyStatus.textContent = notifyStatus.getAttribute('data-error');
          })
          .finally(function () {
            button.disabled = false;
          });
      });
    }

    // Quantity
    root.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-bdek-qty]');
      if (!qtyBtn) return;
      var input = qtyBtn.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-bdek-qty'), 10));
      input.value = next;
    });

    // Add to cart
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        if (!idInput.value || addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
        // Instant feedback: Shopify's add + the drawer rebuild can take a second or two on phones
        addText.textContent = labels.adding || addText.textContent;
        if (stickyBtn) stickyBtn.textContent = addText.textContent;

        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (json) {
              if (!response.ok) throw new Error(json.description || json.message || 'Could not add to cart');
              return json;
            });
          })
          .then(function (product) {
            form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: product } }));
            updateFreeShipping();
          })
          .catch(function (error) {
            setMessage(false, error.message);
          })
          .finally(function () {
            addBtn.removeAttribute('aria-busy');
            refresh(false);
          });
      });
    }

    // Tap to zoom: full-screen photos; swipe (phones) or arrows (desktop); tap/click a photo to zoom in on that spot
    var zoom = root.querySelector('[data-bdek-zoom]');
    var zoomOpener = null;
    if (zoom && zoom.showModal) {
      var zoomList = zoom.querySelector('[data-bdek-zoom-list]');
      var zoomSlides = Array.prototype.slice.call(zoom.querySelectorAll('.bdek-zoom__slide'));
      var zoomCurrent = zoom.querySelector('[data-bdek-zoom-current]');
      var zoomIndex = 0;

      function goTo(index, smooth) {
        zoomIndex = Math.max(0, Math.min(zoomSlides.length - 1, index));
        zoomSlides.forEach(function (sl) { sl.classList.remove('is-zoomed'); });
        zoomList.scrollTo({ left: zoomSlides[zoomIndex].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        if (zoomCurrent) zoomCurrent.textContent = zoomIndex + 1;
      }

      root.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-bdek-zoom-open]');
        if (!opener) return;
        zoomOpener = opener;
        var id = opener.getAttribute('data-bdek-zoom-open');
        var index = zoomSlides.findIndex(function (sl) { return sl.getAttribute('data-media-id') === id; });
        zoom.showModal();
        document.documentElement.classList.add('bdek-no-scroll');
        goTo(index < 0 ? 0 : index, false);
      });

      zoom.addEventListener('click', function (event) {
        if (event.target.closest('[data-bdek-zoom-close]')) { zoom.close(); return; }
        var step = event.target.closest('[data-bdek-zoom-step]');
        if (step) { goTo(zoomIndex + parseInt(step.getAttribute('data-bdek-zoom-step'), 10), true); return; }
        var img = event.target.closest('[data-bdek-zoom-img]');
        if (img) {
          var slide = img.parentElement;
          if (!slide.classList.contains('is-zoomed')) {
            var rect = img.getBoundingClientRect();
            img.style.transformOrigin = ((event.clientX - rect.left) / rect.width * 100) + '% ' + ((event.clientY - rect.top) / rect.height * 100) + '%';
          }
          slide.classList.toggle('is-zoomed');
        }
      });

      // While zoomed, follow the pointer (desktop)
      zoom.addEventListener('mousemove', function (event) {
        var slide = event.target.closest('.bdek-zoom__slide.is-zoomed');
        if (!slide) return;
        var img = slide.querySelector('[data-bdek-zoom-img]');
        var rect = slide.getBoundingClientRect();
        img.style.transformOrigin = ((event.clientX - rect.left) / rect.width * 100) + '% ' + ((event.clientY - rect.top) / rect.height * 100) + '%';
      });

      zoom.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') goTo(zoomIndex + 1, true);
        if (event.key === 'ArrowLeft') goTo(zoomIndex - 1, true);
      });

      zoomList.addEventListener('scroll', function () {
        var i = Math.round(zoomList.scrollLeft / Math.max(1, zoomList.clientWidth));
        if (i !== zoomIndex) {
          zoomSlides.forEach(function (sl) { sl.classList.remove('is-zoomed'); });
          zoomIndex = i;
          if (zoomCurrent) zoomCurrent.textContent = i + 1;
        }
      }, { passive: true });

      zoom.addEventListener('close', function () {
        document.documentElement.classList.remove('bdek-no-scroll');
        if (zoomOpener) zoomOpener.focus();
      });
    }

    // Size guide
    var guide = root.querySelector('[data-bdek-size-guide]');
    var guideOpener = null;
    if (guide && guide.showModal) {
      root.addEventListener('click', function (event) {
        var open = event.target.closest('[data-bdek-size-guide-open]');
        if (open) {
          guideOpener = open;
          guide.showModal();
          return;
        }
        if (event.target.closest('[data-bdek-size-guide-close]') || event.target === guide) guide.close();
      });
      guide.addEventListener('close', function () {
        if (guideOpener) guideOpener.focus();
      });
    }

    // Phone gallery counter
    var counter = root.querySelector('[data-bdek-gallery-current]');
    if (gallery && counter) {
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        counter.textContent = index + 1;
      }, { passive: true });
    }

    // Free shipping bar
    var freeship = root.querySelector('[data-bdek-freeship]');
    function updateFreeShipping() {
      if (!freeship || !window.fetch) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var threshold = parseInt(freeship.getAttribute('data-threshold'), 10) || 0;
          if (!threshold) return;
          var total = cart.total_price || 0;
          var left = Math.max(0, threshold - total);
          var pct = Math.min(100, Math.round((total / threshold) * 100));
          var text = freeship.querySelector('[data-bdek-freeship-text]');
          var bar = freeship.querySelector('[data-bdek-freeship-bar]');
          var fill = freeship.querySelector('[data-bdek-freeship-fill]');
          freeship.classList.toggle('is-done', left === 0);
          if (total > 0) {
            text.textContent = left === 0
              ? freeship.getAttribute('data-text-done')
              : freeship.getAttribute('data-text-away').replace('[amount]', formatMoney(left, freeship.getAttribute('data-money-format')));
          }
          bar.setAttribute('aria-valuenow', pct);
          fill.style.width = pct + '%';
        })
        .catch(function () {});
    }
    updateFreeShipping();
    document.addEventListener('cart:updated', updateFreeShipping);

    // Sticky bar (phones): shows once the main button has scrolled out of view above
    if (sticky && addBtn) {
      var ticking = false;
      var checkSticky = function () {
        ticking = false;
        sticky.hidden = addBtn.getBoundingClientRect().bottom > 0;
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(checkSticky);
      }, { passive: true });
      checkSticky();

      stickyBtn.addEventListener('click', function () {
        if (!addBtn.disabled && idInput.value) {
          if (form.requestSubmit) form.requestSubmit(addBtn);
          else addBtn.click();
          return;
        }
        var target = root.querySelector('[data-bdek-option]') || addBtn;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstInput = target.querySelector && target.querySelector('[data-bdek-option-input]');
        if (firstInput) firstInput.focus({ preventScroll: true });
      });
    }

    refresh(false);
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
